<template>

    <div class="main-container" v-if="completeLoad">

        <div class="back-route" @click.stop="router.push(`/course/${route.params.courseId}`)"><i class="material-icons">keyboard_arrow_left</i><span>Volver al curso</span></div>

        <div class="resume">
            <Chart :title="reportData.pie.name" :graphicColors="graphicColors" :graphicData="reportData.pie.items" @filterReport="(userSituation)=>getData(userSituation)"/>
            <div class="title">
                <span><h3>{{reportData.pie.name}}</h3></span> 
                <div class="total-alumns">Total Participantes: <span>{{reportData.pie.totalAlumns}}</span></div>
            </div>
        </div>

        <div class="filter-acitve" v-if="filterActive">
            <span>Filtrando por:</span>
            <div class="filter-acitve__tag">
                <span>{{$t(`tutor.report.userSituation.${filterActive}`)}}</span>
                <i class="material-icons" @click.stop="getData(null)">close</i>
            </div>
        </div>

        <div class="full-table">

            <div class="downloadReport">
                <h4 class="downloadReport--h4">Seguimiento de actividades</h4>
                <button class="download-excel" @click.stop="downloadExcel()" :disabled="downloadingExcel"><i class="material-icons">file_download</i>{{downloadingExcel ? 'Descargando...' : 'Descargar excel'}}</button>
            </div>

            <!-- TABLE -->
            <div class="table-container">

                <div class="table">

                    <div class="table-header">

                        <div class="header-cell table-title students-title">Participantes</div>

                        <div class="unit" v-for="(unit, unitIdx) in reportData.table.units" :key="unitIdx">
                            <div class="table-title unit-title">{{unit.unitTitle}}</div>
                            <div class="unit-container">
                                <div class="modules">
                                    <div v-for="(mod, modIdx) in unit.modules" :key="modIdx" class="module">
                                        <div class="table-title">{{mod.moduleTitle}}</div>
                                        <div class="contents">
                                            <div class="header-cell content" v-for="(content,contentIdx) in mod.contents" :key="contentIdx">
                                                <a class="table-title" :href="content.url" target="_blank">{{content.displayName}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="header-cell unit-progress table-title">{{unit.progressPercentageColName}}</div>
                            </div>
                        </div>

                        <div class="header-cell total-progress table-title">{{reportData.table.totalProgressCol.colName}}</div>
                        <div class="header-cell total-progress table-title">{{reportData.table.totalToDateProgressCol.colName}}</div>
                        <div class="header-cell total-progress table-title">Certificó</div>

                        <div class="optative-activities module" v-if="reportData.table.optativeActivities.contents.length">
                            <div class="table-title unit-title">{{reportData.table.optativeActivities.displayName}}</div>
                            <div class="contents">
                                <div class="header-cell content" v-for="(content,contentIdx) in reportData.table.optativeActivities.contents" :key="contentIdx">
                                    <a class="table-title" :href="content.url" target="_blank">{{content.displayName}}</a>
                                </div>
                            </div>
                        </div>

                        <div class="header-cell optative-progress table-title" v-if="reportData.table.optativeActivities.contents.length">{{reportData.table.optativeActivities.totalProgressCol.colName}}</div>

                    </div><!-- /table-header -->

                    <div class="data-container">

                        <div class="data-column students">
                            <div class="data-cell student-name" v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx"> 
                                <div class="student-name--color" 
                                :style="{backgroundColor: student.userSituation == 'END_NONE_CONTENT' 
                                    ? '#F62E53' 
                                    : student.userSituation == 'END_SOME_CONTENT'
                                        ? '#F3BF3D'
                                        : '#009696'}">
                                </div>
                                {{student.displayName}}
                            </div>                    
                        </div>

                        <!-- Unit -->
                        <template v-for="(unit, unitIdx) in reportData.table.units" :key="unitIdx">
                            <template v-for="(mod, modIdx) in unit.modules" :key="modIdx">
                                <template v-for="(content,contentIdx) in mod.contents" :key="contentIdx">
                                    <div class="data-column">
                                        <template v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx">
                                            <div class="data-cell">
                                                <a :href="student.data[content.code].url" target="_blank"
                                                :class="{'NotFinished--a': student.data[content.code].value == 'NotFinished', 'FinishedOutOfTime--a': student.data[content.code].value === 'FinishedOutOfTime', 'FinishedInTime--a': student.data[content.code].value === 'FinishedInTime'}">
                                                    {{$t(`tutor.report.activityStatus.${student.data[content.code].value}`)}}
                                                </a>
                                            </div>
                                        </template>                               
                                    </div>
                                </template>
                            </template>
                            <div class="data-column">
                                <div v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx" class="data-cell">{{student.data[unit.progressPercentageColCode].value}} %</div>
                            </div>
                        </template><!-- /Unit -->

                        <!-- total progress -->
                        <div class="data-column"> 
                            <div v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx" class="data-cell">{{student.data[reportData.table.totalProgressCol.colCode].value}} %</div>
                        </div>

                        <!-- total progress to date -->
                        <div class="data-column"> 
                            <div v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx" class="data-cell">{{student.data[reportData.table.totalToDateProgressCol.colCode].value}} %</div>
                        </div>

                        <!-- Certificò  -->

                        <div class="data-column"> 
                            <div v-for="(student, studentIdx) in reportData.table.rows" :key="studentIdx" class="data-cell">{{ student.canCertificate ? 'Si' : 'No' }}</div>
                        </div>

                        <!-- optative activities -->    
                        <div class="data-column" v-for="(content,contentIdx) in reportData.table.optativeActivities.contents" :key="contentIdx">                         
                            <div v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx" class="data-cell">
                                <a :href="student.data['O_'+content.code].url" target="_blank"
                                :class="{'NotFinished--a': student.data['O_'+content.code].value == 'NotFinished', 'FinishedOutOfTime--a': student.data['O_'+content.code].value === 'FinishedOutOfTime', 'FinishedInTime--a': student.data['O_'+content.code].value === 'FinishedInTime'}">
                                    {{$t(`tutor.report.activityStatus.${student.data['O_'+content.code].value}`)}}
                                </a>
                            </div>
                        </div>

                        <!-- optative progress -->
                        <div class="data-column" v-if="reportData.table.optativeActivities.contents.length"> 
                            <div v-for="(student,studentIdx) in reportData.table.rows" :key="studentIdx" class="data-cell">{{student.data[reportData.table.optativeActivities.totalProgressCol.colCode].value}} %</div>
                        </div>

                    </div> <!-- /data-container -->

                </div> <!-- /table -->

            </div> <!-- /table-container -->

        </div> <!-- /full-table -->

    </div> <!-- /main-container -->
    <loader v-else/>

</template>

<script>
import { onMounted, ref } from 'vue-demi';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Chart from '@/components/TutorReportChart.vue';
import Loader from '../components/Loader.vue';
import { computed } from '@vue/reactivity';
export default {
    components: {
        Chart,
        Loader,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const reportData = ref();
        const completeLoad = ref(false);
        const filterActive = ref(null);
        const downloadingExcel = ref(false);
        const user = computed(() => store.getters.manageUser_user);
        const graphicColors = {
            END_NONE_CONTENT: 'red',
            END_SOME_CONTENT: 'yellow',
            END_ALL_CONTENT: 'green'
        }

        async function getData(userSituation=null){
            completeLoad.value = false;
            try {
                let req = await store.dispatch('courses_tutorReport',{courseId: route.params.courseId, userSituation});
                reportData.value = req.data;
                console.log(reportData.value.table.optativeActivities.contents)
                reportData.value.pie.totalAlumns = 0;
                reportData.value.pie.items.forEach(item => {
                    reportData.value.pie.totalAlumns += item.value;
                });
                filterActive.value = userSituation;
                completeLoad.value = true;
            } catch (error) {
                console.log(error);
                if(error.response.data == 'USER_ROLE_NOT_ALLOWED') router.push('/notAllowed');
                else store.dispatch('notifications_create', {text: 'Ocurrió un error al cargar los datos'});
            }
        }

        async function downloadExcel(){
            downloadingExcel.value = true;
            try {
                await store.dispatch('courses_tutorReportExcel',{courseId: route.params.courseId, fileName: 'Reporte_'+ reportData.value.pie.name, userSituation: filterActive.value});
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', {text: 'Error al intentar descargar archivo'})
            } finally{
                downloadingExcel.value = false;
            }
        }

        onMounted(() => {
            if (!user.value.permissions.includes('CURSO_REPORTES')) return
            getData()
        }
        );
              
        return {
            reportData,
            completeLoad,
            graphicColors,
            getData,
            filterActive,
            downloadExcel,
            downloadingExcel,
            router,
            route
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

$cellWidth: 230px;
$cellHeight: 60px;
$cellPadding: 4px;
$cellBorder: 1px solid #e9e6e6;

.back-route{
    width: fit-content;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}
.main-container{
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.resume{
    display: flex;
    align-items: center;
    justify-content: space-around;
    @media screen and (max-width: $bpBig) {
        flex-direction: column;
        gap: 24px;
        .graphic__container{
            justify-content: center;
            gap: 10px;
        }
    }
    .title{
        //align-self: stretch;
        @include flex-column;
        gap: 24px;
        font-size: 32px;
        color: map-get($dark, 1000);
        font-weight: 600;
        span{
            text-align: center;
        }
        h3{
            display: inline;
            font-size: 32px;
            font-weight: 700;
            font-style: italic;
        }
        .total-alumns{
            color: map-get($dark, 1000);
            font-size: 20px;
            font-weight: 500;
            span{
                font-weight: 600;
            }
        }
    }
}

.filter-acitve{
    display: flex;
    gap: 12px;
    >span{
        font-weight: 500;
    }
    &__tag{
        display: flex;
        align-items: center;
        gap: 8px;
        background: $green;
        border-radius: 12px;
        padding: 3px 10px;
        span{
            color: #fff;
            font-size: 14px;
        }
        .material-icons{
            font-size: 20px;
            line-height: 14px;
            cursor: pointer;
        }
    }
}

.downloadReport{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 30px;
    background-color: #fff;
}
.download-excel{
    align-self: flex-end;
    width: fit-content;
    padding: 12px;
    position: sticky;
    bottom: 10px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: map-get($primary, 500);
    font-size: 14px;
    font-weight: 600;
    .material-icons{
        font-size: 16px;
    }
    &:disabled{
        opacity: .6;
        cursor: default;
    }
}

/* TABLE */
.full-table{
    height: fit-content;
    max-height: calc(100vh - 72px);
    @include flex-column;
}

.table-container{
    width: 100%;
    //max-height: 76vh;
    height: 100%;
    overflow: scroll;
    &::-webkit-scrollbar-track {
        border-radius: 100px;
        background-color: rgba(0,0,0,.1);
        //margin: 4px 0;
    }
    &::-webkit-scrollbar {
        width: 10px;
        height: 14px;
        background-color: transparent;
        margin: 4px 0;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background: map-get($dark, 400);
        position: absolute;
    }
}
.table{
    position: relative;
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    background: #fff;
    .table-title{
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        color: $black;
    }
    .table-header{
        position: sticky;
        top: 0px;
        display: flex;
        background: #fff;
        z-index: 500;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        .unit{
            width: fit-content;
            @include flex-column;
            border-right: $cellBorder;
            border-top: $cellBorder;
            &-title{
                width: 100%;
                padding: $cellPadding;
                text-align: center;
                font-weight: 700;
                color: map-get($dark, 1000);
            }
            &-container{
                width: fit-content;
                display: flex;
            }
            .modules{
                width: fit-content;
                display: flex;
                border-top: $cellBorder;
            }
        }
        .module{
            width: fit-content;
            @include flex-column;
            border-right: $cellBorder;
            >.table-title{
                width: 100%;
                text-align: center;
                padding: $cellPadding;
            }
        }
        .contents{
            width: fit-content;
            display: flex;
            flex-grow: 1;
            .content{
                padding: $cellPadding;
                border-right: $cellBorder;
                text-align: center;
                &:last-child{
                    border-right: none;
                    width: calc(#{$cellWidth} - 1px);
                }
            }
        }
        .header-cell{
            width: $cellWidth;
            //max-height: $cellHeight;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: $cellBorder;
            padding: $cellPadding;
            text-align: center;
            &.students-title{
                position: sticky;
                left: 0px;
                background: #fff;
                border-right: $cellBorder;
                font-size: 17px;
                min-width: 230px;
                max-width: 230px;
            }
        }
        .optative-activities{
            border-top: $cellBorder;
        }
        .unit-progress{
            border-top: none;
            border-top: $cellBorder;
            width: calc(#{$cellWidth} - 1px);
        }
        .total-progress{
            border-right: $cellBorder;
            font-size: 17px;
            min-width: 230px;
            max-width: 230px;
        }
        .optative-progress{
            padding: 4px 12px;
            font-size: 17px;
            text-align: center;
        }
    }
    .data{
        &-container{
            display: flex;
        }
        &-column{
            @include flex-column;
            &.students{
                position: sticky;
                left: 0px;
                box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
                .student-name{
                    background: #fff;
                }
            }
        }
        &-cell{
            width: $cellWidth;
            min-height: $cellHeight;
            max-height: $cellHeight;
            padding: $cellPadding;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: $cellBorder;
            border-right: $cellBorder;
            font-size: 13px;
            font-weight: 500;
        }
    }
    .student-name{
        color: map-get($dark, 800);
        font-weight: 600;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        gap: 8px;
        .student-name--color{
            margin-left: 8px;
            width: 38px;
            height: 16px;
            border-radius: 10px;
        }
    }
}
/* end TABLE */

.loader__container{
    height: 88vh;
}

</style>